import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';

import AddControl from 'components/add_control';
import { Button } from 'components/ui/button';

import './styles.scss';

export default function FieldsCollection({
  addLabel = 'Add',
  children,
  full,

  // Only relevant when there is only one child, to hide the remove control
  hasValue,

  onAdd,

  // Called when "removing" the final child
  // Using onRemoveIndex instead would cause flickering by the effect hook
  onClear,

  onRemoveIndex,
}) {
  React.useEffect(() => {
    if (children.length === 0) {
      onAdd();
    }
  }, [children]);

  return <div className="mb-3">
    {React.Children.map(children, (child, i) => (
      <div className="deal-fields-collection-item" key={i} name="child">
        {child}

        <Button
          className={classNames('ms-1', {
            invisible: child.props.removable === false || (!hasValue && children.length === 1)
          })}
          icon={faTrash}
          variant="ghost"
          onClick={() => children.length === 1 ? onClear() : onRemoveIndex(i)}
        />
      </div>
    ))}

    {!full && <AddControl className="d-inline-block mt-1" onClick={onAdd}>{addLabel}</AddControl>}
  </div>;
}

FieldsCollection.propTypes = {
  addLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
  full: PropTypes.bool,
  hasValue: PropTypes.bool,
  onAdd: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  onRemoveIndex: PropTypes.func.isRequired,
};
